import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBeneficiaries, getBeneficiariesRelationships } from '../../../../../global/ducks/benadmin-api';
import { getTcsmEpiProps, setBeneficiarySeetings } from '../../../../../global/ducks/epi-api';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';
import { setBeneficiaries, setBeneficiariesRelationships } from '../beneficiary-slices';


export function useBeneficiarySettings(settingsId: string) {
	const dispatch = useDispatch();
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);
	const beneficiaryLoaded = useSelector<TcsmStates, boolean>(state => state?.beneficiariesState?.loaded);
	const beneficiarySettingsLoaded = epiApiState?.beneficiarySettingsState?.contentLoaded;
	const beneficiaryRelationshipsLoaded = useSelector<TcsmStates, boolean>(state => state?.beneficiariesState?.relationshipsLoaded);

	useEffect(() => {
		if (!beneficiarySettingsLoaded) {
			dispatch(getTcsmEpiProps(dispatch, settingsId, { guid }, language, false, setBeneficiarySeetings));
		}

		if (!beneficiaryLoaded) {
			dispatch(getBeneficiaries(guid, (res => dispatch(setBeneficiaries(res?.data)))));
		}

		if (!beneficiaryRelationshipsLoaded) {
			dispatch(getBeneficiariesRelationships(guid, (res => dispatch(setBeneficiariesRelationships(res?.data)))));
		}
	}, []);

	return beneficiarySettingsLoaded && beneficiaryLoaded && beneficiaryRelationshipsLoaded;
}